import { useQuery } from "@apollo/client";
import { t } from "i18next";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getVips } from "../../api/getVips";
import { Loader } from "../../components/Loader";
import { useAppContext } from "../../contexts/AppContext";
import { showErrorMessage } from "../../helper/helper";
import { VipEntry } from "../../models/VipEntry";
import { MillVipTable } from "./MillVipTable";

export const SpecialPrices: React.FC = () => {

    const { millSelected } = useAppContext()
    const token = useSelector((state: any) => state.token.value)
    const buyerId = millSelected?.id

    const [vips, setVips] = useState<VipEntry[]>([])

    const { loading, refetch } = useQuery(getVips, {
        skip: !token || !buyerId,
        variables: { filter: { buyer_id: buyerId } },
        fetchPolicy: 'no-cache',
        notifyOnNetworkStatusChange: true,
        onCompleted: (data) => {
            setVips((data?.sarana_get_vips ?? [])
                .map((v: any) => VipEntry.build(v))
                .sort((a: VipEntry, b: VipEntry) => b.transactor_id - a.transactor_id))
        },
        onError: (e) => showErrorMessage(e),
    })

    useEffect(() => {
        if (token && buyerId) refetch()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [buyerId])

    const millVips = vips.filter((v) => v.is_mill_vip)

    return (
        <div className="pempem-flex-col gap10">
            <div className="header">
                <h1>{t('special_prices')}</h1>
            </div>
            <div className="page-padding">
                <MillVipTable entries={millVips} buyerId={buyerId} refetch={refetch} />
            </div>
            <Loader isLoading={loading} />
        </div>
    )
}
